import React from 'react'
import Header from '../../../layouts/doctor/DoctorHeader'

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Auditlogs } from './Auditlogs';
import { Loginlogs } from './Loginlogs';
import { useSelector } from 'react-redux';
import { selectLoc } from '../../../redux/slice/locSlice';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import useHeaders from '../../../helpers/useHeaders';
import path from '../../../path';
import useEncryption from '../../../services/useEncryption';
import { toast } from 'react-toastify';
import { exportLogsCsvApi } from '../../../api/userApi/userApi';
import { useParams } from 'react-router-dom';


export const Logs = () => {

  const [value, setValue] = React.useState('1');
  const [search, setSearch] = React.useState("");
  const { selectedLogs } = useSelector(selectLoc);
  const headers = useHeaders();
  const { encryptData, decryptData } = useEncryption();
  const { id } = useParams();
  let decryptId = decryptData(id);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const downloadCSVFile = async () => {
    try {
      if (selectedLogs.length == 0) {
        toast.error("Please select some records to export in CSV File.");
        return
      }
      const recordsEnc = encryptData(selectedLogs);
      const idEnc = encryptData(decryptId);
      const response = await exportLogsCsvApi(recordsEnc, idEnc);
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'logs.csv');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      let obj = {
        event: 'Doctor has download the CSV file for Logs.'
      }
      await createAuditLogs({ data: encryptData(obj) }, headers);
    } catch (error) {
      console.error('Error downloading logs CSV:', error);
    }
  };

  return (
    <div>
      <Header pageTitle="Logs" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">
            Log Details
          </div>
          {/* <button className="btn blackoutlineBtn">Refresh</button> */}
        </div>
        <div className="cardcontents">
          <TabContext className="tabsDesigns" value={value}>
            <Tabs className='butoontabdesigns' onChange={handleChange} >
              <Tab className={value === "1" ? "actived" : ""} label="Audit Logs" value="1" />
              <Tab className={value === "2" ? "actived" : ""} label="Login Logs" value="2" />
            </Tabs>
            <TabPanel className='tabpanelControl' value="1">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="searchBar">
                    <input type="text" autoComplete='off' placeholder='Search' value={search} onChange={(event) => setSearch(event.target.value)} />
                  </div>
                  <button className="btn blackoutlineBtn" onClick={downloadCSVFile} >Download CSV</button>
                </div>
                <Auditlogs type="audit" search={search} />
              </div>
            </TabPanel>
            <TabPanel className='tabpanelControl' value="2">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="searchBar">
                    <input type="text" autoComplete='off' placeholder='Search' value={search} onChange={(event) => setSearch(event.target.value)} />
                  </div>
                  <button className="btn blackoutlineBtn" onClick={downloadCSVFile} >Download CSV</button>
                </div>
                <Auditlogs type="login" search={search} />
              </div>
            </TabPanel>
          </TabContext>
        </div>
      </div></div>
  )
}
